const isRef = require('./is-ref');

/**
 * Parse the path from a graph reference object
 * @param {Object} ref The graph reference object
 * @return {string} The graph reference path
 * @throws {Error} Throws if no reference is specified
 * @throws {Error} Throws if the specified reference does not have a valid `value` field
 */
function parseRef(ref) {
  if (!isRef(ref)) { throw new Error(`Invalid reference: ${ref}`); }
  if ((typeof ref.value !== 'string') || !ref.value) {
    throw new Error(`Invalid reference value: ${ref.value}`);
  }
  return ref.value;
}

module.exports = parseRef;
